export default "__VITE_ASSET__CaUtUk$r__"